import {isAutohomeApp} from '../../../../common/util';
export default {
    data: {
        //容器标识
        isInApp: /auto_android|auto_iphone/.test(navigator.userAgent),
        //是否已经弹出过IM询问框
        hasIntercepted: false,
        // 是否加载完成JSBridge
        isGetJSBridge: false,
        envBase: 0 // 1 ->app, 2 -> web
    },
    methods: {
        // 加载JSBridge
        getJSBridge: function () {
            var _this = this;
            if (isAutohomeApp()) {
                // 在app里
                _this.env = 1;
                var body = document.querySelector('body');
                var script1 = document.createElement('script');
                body.appendChild(script1);
                script1.src = 'https://x.autoimg.cn/app/scripts/ahapp-2.0.js';
                script1.onload = function () {
                    _this.isGetJSBridge = true;
                };
            } else {
                // 不在app里
                _this.env = 2;
            }
        },
        // 比较主软的版本
        compareAppVersion: function (now, appoint) {
            var nowArr = now.split('.');
            var appointArr = appoint.split('.');
            for (var i = 0; i < 3; i++) {
                nowArr[i] = parseFloat(nowArr[i]);
                appointArr[i] = parseFloat(appointArr[i]);
            }
            if (nowArr[0] > appointArr[0]) {
                return 'nowBig';
            } else if (nowArr[0] == appointArr[0]) {
                if (nowArr[1] > appointArr[1]) {
                    return 'nowBig';
                } else if (nowArr[1] == appointArr[1]) {
                    if (nowArr[2] > appointArr[2]) {
                        return 'nowBig';
                    } else if (nowArr[2] == appointArr[2]) {
                        return 'equal'
                    } else {
                        return 'appointBig'
                    }
                } else {
                    return 'appointBig'
                }
            } else {
                return 'appointBig'
            }
        }
        
    },
}